<template>
    <v-list nav dense>
        <template>
            <v-list-item
                    link
                    router to="/fraccionamientos"
            >
                <v-list-item-action>
                    <v-icon>mdi-home-city</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('Fraccionamientos')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/managers"
            >
                <v-list-item-action>
                    <v-icon>mdi-account-group</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Administradores')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/settings"
            >
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('configuracion')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/ayuda"
            >
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Ayuda')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
<!--            <v-list-group-->
<!--                    prepend-icon="mdi-account"-->
<!--                    append-icon=""-->
<!--            >-->
<!--                <template v-slot:activator>-->
<!--                    <v-list-item>-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title>-->
<!--                                Cuenta-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->
<!--                    </v-list-item>-->
<!--                </template>-->
<!--                <v-list-item-->
<!--                        link-->
<!--                        router to="/aaa"-->
<!--                >-->
<!--                    <v-list-item-action>-->
<!--                        &lt;!&ndash;<v-icon>mdi-help-circle</v-icon>&ndash;&gt;-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>-->
<!--                            Cambiar Foto Perfil-->
<!--                        </v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
<!--                <v-list-item-->
<!--                        link-->
<!--                        router to="/bbb"-->
<!--                >-->
<!--                    <v-list-item-action>-->
<!--                        &lt;!&ndash;<v-icon>mdi-help-circle</v-icon>&ndash;&gt;-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>-->
<!--                            Cambiar Password-->
<!--                        </v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
<!--                <v-list-item-->
<!--                        link-->
<!--                        router to="/ccc"-->
<!--                >-->
<!--                    <v-list-item-action>-->
<!--                        &lt;!&ndash;<v-icon>mdi-help-circle</v-icon>&ndash;&gt;-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>-->
<!--                            Cambiar Datos-->
<!--                        </v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
<!--            </v-list-group>-->
<!--            <v-list-group-->
<!--                    prepend-icon="mdi-help-network"-->
<!--                    append-icon=""-->
<!--            >-->
<!--                <template v-slot:activator>-->
<!--                    <v-list-item>-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title>-->
<!--                                Cuenta-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->
<!--                    </v-list-item>-->
<!--                </template>-->
<!--                <v-list-item-->
<!--                        link-->
<!--                        router to="/ddd"-->
<!--                >-->
<!--                    <v-list-item-action>-->
<!--                        &lt;!&ndash;<v-icon>mdi-help-circle</v-icon>&ndash;&gt;-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>-->
<!--                            Hola-->
<!--                        </v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
<!--                <v-list-item-->
<!--                        link-->
<!--                        router to="/eee"-->
<!--                >-->
<!--                    <v-list-item-action>-->
<!--                        &lt;!&ndash;<v-icon>mdi-life-febouy</v-icon>&ndash;&gt;-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>-->
<!--                            Adios-->
<!--                        </v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
<!--            </v-list-group>-->
        </template>
    </v-list>
</template>

<script>
export default {
  name: 'super_admin'
}
</script>

<style scoped>

</style>
